export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
                移动观影 · 随时随地
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                91电影移动端完美适配，在手机和平板上同样享受高清流畅的<strong>免费在线观看</strong>体验。无论通勤路上还是睡前时光，打开浏览器即可观看最新<strong>国产电影免费</strong>大片，无需下载任何APP。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                <span className="flex items-center gap-2 text-foreground-500 text-sm">
                  <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  浏览器即开即看
                </span>
                <span className="flex items-center gap-2 text-foreground-500 text-sm">
                  <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  自适应屏幕
                </span>
                <span className="flex items-center gap-2 text-foreground-500 text-sm">
                  <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  省流量模式
                </span>
              </div>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-smartphone-line w-4 h-4 flex items-center justify-center"></i>
                立即体验
              </a>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-[200px] h-[360px] md:w-[240px] md:h-[420px] rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(245,158,11,0.1)]">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20elegant%20movie%20streaming%20interface%20with%20dark%20theme%2C%20golden%20amber%20accent%20colors%2C%20film%20poster%20thumbnails%20in%20grid%20layout%2C%20minimalist%20UI%20design%2C%20cinematic%20dark%20background%20with%20warm%20highlights%2C%20modern%20app%20interface%20aesthetic&width=480&height=840&seq=app-preview-91movie&orientation=portrait"
                  alt="91电影移动端界面预览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}